import React from 'react'
import './ModalWide.css'

const ModalUserDelete = ({closeModal, onSubmit, userInfo}) => {
    const handleConfirm = async (e) => {
        e.preventDefault();
        await onSubmit();
        closeModal();
    }

    const handleCancel = (e) => {
        e.preventDefault();
        closeModal();
    }

    return (
        <div className='modal-container' onClick={(e) => {
            if (e.target.className === 'modal-container') {
                closeModal();
            }
        }}>
            <div className='modal-edit user-delete-modal'>
                <form>
                    <div className='row'>
                        <div className='column-full'>
                            <div className='form-group'>
                                <p className='user-delete-message'>
                                    Are you sure you want to deactivate user {userInfo?.first_name} {userInfo?.last_name}? (User ID: {userInfo?.id})
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className='user-delete-actions'>
                        <button type='button' className='btn user-delete-cancel-btn' onClick={handleCancel}>Cancel</button>
                        <button type='button' className='btn user-delete-deactivate-btn' onClick={handleConfirm}>Deactivate</button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ModalUserDelete